// src/pages/IlkokulOrtaokulPage.jsx
import React from 'react';
import NavBar from '../components/NavBar';
import './IlkokulOrtaokulPage.css';
import headerImg from '../assets/okul.jpg';
import i1 from '../assets/i1.jpeg';
import i2 from '../assets/i2.jpeg';
import i3 from '../assets/i3.jpeg';
import i4 from '../assets/i4.jpg';
import i5 from '../assets/i5.jpg';
import i6 from '../assets/i6.jpeg';
import i7 from '../assets/i7.jpeg';
import i8 from '../assets/i8.jpeg';
import i9 from '../assets/i9.jpeg';
import i10 from '../assets/i10.jpeg';
import i11 from '../assets/i11.jpeg';

export default function IlkokulOrtaokulPage() {
  return (
    <>
      <NavBar />

      <section id="ilkokul-ortaokul-page" className="ilkokul-ortaokul-page">
        {/* Hero */}
        <div
          className="hero-bg"
          style={{ backgroundImage: `url(${headerImg})` }}
        >
          <div className="overlay" />
          <h1 className="hero-title">İlkokul ve Ortaokul</h1>
        </div>

        {/* İlkokul Bölümü */}
        <div className="subsection" id="primary-section">
          <h2>İlkokul</h2>
          <h3>Alternatif Bir Okul: YELDEĞİRMENİ</h3>
          <p>
            Her çocuğun dünyaya kendine özgü bir ışıkla geldiğine inanıyoruz. Bu yüzden biz, öğrenmenin kalıplara sığmadığı, her öğrencinin potansiyelinin sevgiyle fark edildiği ve geliştiği bir eğitim anlayışını benimsiyoruz. Okulumuz, akademik bilgiden önce insan olmanın, öğrenmeyi sevmenin ve kendini keşfetmenin ön planda olduğu alternatif bir ilkokuldur.
          </p>
          <h3>Bireysel Öğrenme, Ortak Yolculuk</h3>
          <p>
            Her çocuk kendi ritmiyle öğrenir. Biz, hazırbulunuşluk düzeyine göre şekillenen, merakı besleyen ve sorgulamayı teşvik eden bir eğitim ortamı sunarız. Ezber yerine keşfi, rekabet yerine iş birliğini, “başarılı olmak” yerine bütünsel gelişimi esas alırız.
          </p>
          <h3>Doğayla İç İçe, Yaşayarak Öğrenme</h3>
          <p>
            Sınıf duvarlarıyla sınırlı kalmayan bir öğrenme deneyimi sunuyoruz. Zeze’nin Bahçesi’nde doğa yürüyüşleri, bahçe etkinlikleri, atölye çalışmaları ile çocuklar dünyayı dokunarak, hissederek ve deneyimleyerek tanır. Oyun, sanat ve hareket günlük yaşamın ayrılmaz parçalarıdır.
          </p>
          <h3>Duygusal Güven, Sosyal Beceri</h3>
          <p>
            Mutlu çocuk öğrenir. Bu yüzden her öğrencinin kendini güvende, görülmüş ve anlaşılmış hissettiği bir ortam inşa ediyoruz. Duygularla sağlıklı ilişki kurmak, arkadaşlık becerileri geliştirmek ve çatışmaları barışçıl yollarla çözmek kadar değerlidir.
          </p>
          <h3>Sanatla Düşünen, Sorgulayan Bireyler</h3>
          <p>
            Yaratıcılığı teşvik ediyor, sanatın her türüne günlük yaşamda yer veriyoruz. Resim, müzik, drama ve hikâye anlatıcılığı çocukların iç dünyalarını dışa yansıttıkları doğal dilleridir. Bizim için sanat, “ders” değil; ifadenin ve öğrenmenin doğal yoludur.
          </p>
          <h3>Küçük Adımlarla Büyük Bir Yolculuk</h3>
          <p>
            İlkokul, bir çocuğun eğitim hayatındaki ilk büyük yolculuktur. Biz bu yolculukta rehberlik ediyor, onların iç seslerini dinlemeyi öğrenmelerini destekliyoruz. Öğrencilerimiz sadece akademik bilgiyle değil; yaşamla, kendileriyle ve başkalarıyla sağlıklı bağlar kurarak büyüyorlar.
          </p>
          <p>
            Gelecek, bugün birlikte kurduğumuz bu sevgi dolu öğrenme topluluğunda şekilleniyor.
          </p>
        </div>

        {/* Görseller - İlkokul */}
        <div className="images-grid-wrapper">
          <div className="images-grid">
            {[i1, i2, i3, i4].map((src, idx) => (
              <img key={idx} src={src} alt={`İlkokul ${idx + 1}`} />
            ))}
          </div>
        </div>

        {/* Ortaokul Bölümü */}
        <div className="subsection" id="middle-section">
          <h2>Ortaokul</h2>
          <h3>Sınırları Değil, Ufukları Genişletiyoruz</h3>
          <p>
            Ortaokul, çocuğun çocukluktan gençliğe uzanan yolculuğunda en hassas, en dönüştürücü duraktır. Bu dönemde birey olma isteği artar, sorular çoğalır, duygular derinleşir. Biz, tam da bu geçiş döneminde öğrencilerimizin hem akademik hem de duygusal dünyalarına bütüncül bir yaklaşımla eşlik ediyoruz.
          </p>
          <h3>Sorgulayan, Düşünen, Üreten Öğrenciler</h3>
          <p>
            Ezbere değil, anlamaya dayalı bir eğitim anlayışı benimsiyoruz. Merakı teşvik eden, eleştirel düşünmeyi destekleyen, üretkenliği ödüllendiren bir öğrenme ortamı sunuyoruz. Derslerimiz disiplinler arası bütünlükle planlanır; bilimle sanatı, teoriyle uygulamayı buluştururuz.
          </p>
          <h3>Akademik Başarı, Tek Başına Yeterli Değil</h3>
          <p>
            Evet, öğrencilerimizin akademik hedeflerine ulaşmalarını önemsiyoruz. Ancak başarıyı sadece sınav sonuçlarıyla değil; öz güven, sorumluluk alma, iletişim kurabilme ve dünyaya karşı duyarlılık gibi niteliklerle birlikte değerlendiriyoruz. Öğrenmenin duygusal ve sosyal boyutuna da alan tanıyoruz.
          </p>
          <h3>Kendi Yolunu Çizen Gençler</h3>
          <p>
            Ortaokulda her öğrenci kim olduğunu keşfetmeye başlar. Biz bu süreçte onların sesini duyar, fikirlerini önemser, seçimlerine saygı duyarız. Danışmanlık sistemimizle öğrencilerimizi birebir tanır, ihtiyaçlarına göre rehberlik ederiz. Kendi kararlarını alan, kendini tanıyan bireyler yetiştirmek en büyük hedefimizdir.
          </p>
          <h3>Yaşamla Bağ Kurarak Öğrenme</h3>
          <p>
            Ders kitapları kadar gerçek yaşamla da iç içeyiz. Toplumsal sorumluluk projeleri, doğa temelli etkinlikler, atölyeler, geziler ve sosyal girişimler öğrencilerimizin dünyaya karşı aktif yurttaşlar olarak yetişmesini sağlar. Öğrendiklerini hayata geçirebildiklerinde eğitimin anlam kazandığına inanırız.
          </p>
          <h3>Güçlü İlişkiler, Sağlıklı Gelişim</h3>
          <p>
            Ergenlik döneminin duygusal iniş çıkışlarında, güvene dayalı ilişkiler her şeyden değerlidir. Öğrenci-öğretmen, öğrenci-veli ve öğrenci-öğrenci ilişkilerinde açık iletişim, empati ve karşılıklı saygı esastır. Amacımız çocukların dışsal ceza ya da ödül sistemi ile değil, içsel motivasyonuna ve topluluk bilincine dayalı olarak kendi davranışlarını yönetmelerini sağlamaktır.
          </p>
          <p>
            Öğrencinin olumsuz davranışını fark etmesi için cezalandırmak yerine rehberlik edilir. Yeldeğirmeni’nde kurallar çocuklar ve öğretmenlerle birlikte demokratik bir ortamda belirlenir.
          </p>
        </div>

        {/* Görseller - Ortaokul */}
        <div className="images-grid-wrapper">
          <div className="images-grid">
            {[i6, i7, i8, i9].map((src, idx) => (
              <img key={idx} src={src} alt={`Ortaokul ${idx + 1}`} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
